import {JsonObject, JsonProperty} from 'json2typescript';
import {TSMap} from 'typescript-map';
import {TSStringToStringMapConverter} from '../customJsonConverters/TSStringToStringMapConverter';

@JsonObject('Choice')
export class Choice {

    @JsonProperty('texts',TSStringToStringMapConverter)
    texts: TSMap<string,string[]> = new TSMap();  // answers

    @JsonProperty('answer',String)
    answer = '';

    @JsonProperty('no',Number)
    no = 1;
    // subChoices:SubChoice[]; no subChoice concept

    /*constructor(json?:any) {
      // const valSet = new Set<string>();
      this.texts = new Map<string, string[]>();


      // this.subChoices = new Array<SubChoice>();

      if(json!=null) {
              this.no = json.no;
              const entree: { [key: string]: string[]; } = json.texts;
              for (const [key, value] of Object.entries(entree)) {
                  this.texts.set(key, value);
              }
      }

      /*if(json!=null && json[0].texts!=null) {
        for (let i = 0; i < json[0].texts.length; i++) {
          this.texts.set(new SubChoice(json[0].subChoices[i]));
        }
      }*/

   /* }*/

  toJSON() {

    console.log('Calling toJson method');
    return ({
      texts: this.MapToString(),
      answer : this.answer,
      no : this.no
    });
  }


  private  MapToString() {

    const tmp: {[key:number]:number} = {};

    for(const key of this.texts.keys()) {
      tmp[key] = this.texts.get(key);
    }
    return tmp;
  }

}

